export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/facebook-icon.f41cd8ed.svg","height":19,"width":18};